export enum CURRENCY_UNIT {
  VND = 'VND',
  USD = 'USD',
  JPY = 'JPY',
  EUR = 'EUR',
  CAD = 'CAD',
  AUD = 'AUD',
  DKK = 'DKK',
  HKD = 'HKD',
  NOK = 'NOK',
  RUB = 'RUB',
  SGD = 'SGD',
  THB = 'THB',
  GBP = 'GBP',
}

export enum UNIT {
  SQUARE_METER = 'm²',
  CUBIC_METER = 'm³',
  KILOGRAM = 'kg',
  CENTIMETER = 'cm',
  GRAM = 'g',
  LITER = 'l',
  METER = 'm',
  PIECE = 'pc'
}

export enum HTTP_STATUS {
  OK = 200,
  NOT_MODIFIED = 304,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
}

export enum GENERATE_SUBTITLE_STATUS {
  DONE = 'DONE',
  GENERATING = 'GENERATING',
  FAIL = 'FAIL',
  NONE = 'NONE',
}

export enum TAG_COLOR {
  blue = '#108ee9',
  green = '#87d068',
}

export enum DRAG_CATEGORY_ITEM_TYPE {
  UP = 'UP',
  DOWN = 'DOWN',
}

export enum SCENE_SORT_ORDER_TYPE {
  ASC = 'ASC',
  DESC = 'DESC',
  NOT = 'NOT',
}

export enum FUNCTION_BUTTON_OPEN_TYPE {
  IFRAME = 'IFRAME',
  NEW_TAB = 'NEW_TAB',
}
